import React from 'react';
import classNames from './style.module.scss';

interface SignaturePreviewProps {
	signatureUrl: string;
}

const SignaturePreview = (props: SignaturePreviewProps) => {
	return props.signatureUrl ? (
		<>
			<p className={classNames.padPreviewLabel}>Signature: </p>

			<div className={classNames.padPreview}>
				<img
					src={props.signatureUrl}
					alt="Signature"
					className={classNames.padPreviewImage}
				/>
			</div>
		</>
	) : null;
};

export default SignaturePreview;
